// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"eleven-stories-eleven-images-m__wrapper__rAiQk"};